export default __webpack_public_path__ + "0ba487424539ab81b79fe14307e77334.svg";